import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

import { AnalyticsService } from './analytics.service';
import { PageViewEvent } from './analytics.models';

@Injectable({
  providedIn: 'root',
})
export class PageTrackingService {
  private readonly router = inject(Router);
  private readonly analyticsService = inject(AnalyticsService);

  initialize(): void {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        const properties: PageViewEvent = {
          pageName: this.getPageNameFromRoute(event.urlAfterRedirects),
        };
        this.analyticsService.trackPageView(properties);
      });
  }

  private getPageNameFromRoute(url: string): string {
    const route = this.getActivatedRoute(this.router.routerState.root);
    const pageNameFromData = route?.snapshot.data['pageName'];

    if (pageNameFromData) {
      return pageNameFromData;
    }

    return `Unknown - ${this.getUrlPath(url)}`;
  }

  private getActivatedRoute(route: ActivatedRoute): ActivatedRoute | null {
    if (route.firstChild) {
      return this.getActivatedRoute(route.firstChild);
    }
    return route;
  }

  private getUrlPath(url: string): string {
    const path = url.startsWith('/') ? url.substring(1) : url;
    return path.split('?')[0];
  }
}
